import React from "react";

type Props = {
    label?: string;
    value: string;
    onChange: (value: string) => void;
};

export default function TextArea(props: React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLInputElement>, HTMLInputElement> & Props) {
    const { label } = props;

    return (
        <div className={"my-4"}>
            <label
                dangerouslySetInnerHTML={{
                    __html: label,
                }}
                htmlFor={props.id}
                className="mb-2 block text-sm font-medium text-textColor"
            />
            <textarea
                id={props.id}
                rows={4}
                className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500"
                placeholder={props.placeholder}
                value={props.value}
                onChange={e => props.onChange(e.target.value)}
            />
        </div>
    );
}